import React, { useState } from 'react';
import { IGraphData } from '../graph/GraphHooks';
import { IFilter } from '../settings/FilterHooks';
import GraphTitle from './GraphTitle';
import { InputSearch } from './InputSearch';
import { CommunityFilterDropdown } from './CommunityFilterDropdown';
import list from '../../assets/list.png';
import listLight from '../../assets/list-light.png';
import node from '../../assets/node.png';
import nodeLight from '../../assets/node-light.png';

interface ArtistGraphHeaderProps {
  subject: string;
  graphType: string;
  search: any;
  data: IGraphData;
  listView: boolean;
  filters?: IFilter[];
  onChangeFilter?: (filterType: string, name: string, value: boolean) => void;
  selectAll?: (currentFilters: IFilter[], value: boolean) => void;
  setSearch: React.Dispatch<React.SetStateAction<any>>;
  setListView: React.Dispatch<React.SetStateAction<boolean>>;
}
export const ArtistGraphHeader: React.FC<ArtistGraphHeaderProps> = ({
  graphType,
  subject,
  search,
  listView,
  filters,
  onChangeFilter,
  selectAll,
  setListView,
  setSearch
}) => {
  return (
    <div className="flex flex-col">
      <div className="md:flex justify-between">
        <div className="">
          <GraphTitle mappingType={graphType} subject={subject} />
        </div>
        <InputSearch search={search} graphType={graphType} setSearch={setSearch} />
      </div>
      <div className="flex items-center justify-end mt-8 space-x-2">
        {graphType === 'Nettwerk' && filters && onChangeFilter && selectAll && (
          <CommunityFilterDropdown
            filters={filters}
            onChangeFilter={onChangeFilter}
            selectAll={selectAll}
          />
        )}
        <div className="p-2 rounded space-x-2 inline-block w-max-fit bg-white shadow">
          <button onClick={() => setListView(false)}>
            <img className="w-5" src={listView ? nodeLight : node} alt="Map view" />
          </button>
          <button onClick={() => setListView(true)}>
            {' '}
            <img className="w-5" src={listView ? list : listLight} alt="List view" />
          </button>
        </div>
      </div>
    </div>
  );
};
